"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = new Error('The installed version of React does not support Hooks. ' +
    'Upgrade to React v16.8.0 or later.');
